import * as TRANSLATIONS from '../../assets/i18n/en-US.json';
import { TranslationKey } from './enums';
import { ILanguageItemWithLocale } from './shared.interfaces';

export type TranslationMapKey = ((keyof typeof TRANSLATIONS)) | TranslationKey | (string & {});
export type TranslationMap = { [Key in TranslationMapKey]: Key };

export const TRANSLATION_MAP: TranslationMap = Object.keys(TRANSLATIONS).reduce((record, key) => {
    (record as any)[key] = key;
    return record;
}, {} as TranslationMap);

export const USER_DEFAULT_USER_IMAGE = 'assets/img/user-profile-placeholder.png';

export const enum RouteQueryParamName {
    eventId = 'eventId',
}

export const APP_SUPPORTED_LANGUAGES_RECORD: { [languageCode: string]: ILanguageItemWithLocale }= {
    'en-US': {
        label: 'English',
        momentLocaleImportFn: async () => {},
        fullCalendarLocaleConfigFn: async () => ({
            locale: 'en',
        })
    },
    'es-ES': {
        label: 'Spanish',
        momentLocaleImportFn: () => import('moment/locale/es' as any),
        fullCalendarLocaleConfigFn: async () => {
            return import('@fullcalendar/core/locales/es').then(importedLocale => ({
                locale: 'es',
                locales: [importedLocale.default],
            }));
        },
    },
    'fr-FR': {
        label: 'French',
        momentLocaleImportFn: () => import('moment/locale/fr' as any),
        fullCalendarLocaleConfigFn: async () => {
            return import('@fullcalendar/core/locales/fr').then(importedLocale => ({
                locale: 'fr',
                locales: [importedLocale.default],
            }));
        },
    },
    'nl-NL': {
        label: 'Dutch',
        momentLocaleImportFn: () => import('moment/locale/nl' as any),
        fullCalendarLocaleConfigFn: async () => {
            return import('@fullcalendar/core/locales/nl').then(importedLocale => ({
                locale: 'nl',
                locales: [importedLocale.default],
            }));
        },

    },
    'it-IT': {
        label: 'Italian',
        momentLocaleImportFn: () => import('moment/locale/it' as any),
        fullCalendarLocaleConfigFn: async () => {
            return import('@fullcalendar/core/locales/it').then(importedLocale => ({
                locale: 'it',
                locales: [importedLocale.default],
            }));
        },
    },
    'de-DE': {
        label: 'German',
        momentLocaleImportFn: () => import('moment/locale/de' as any),
        fullCalendarLocaleConfigFn: async () => {
            return import('@fullcalendar/core/locales/de').then(importedLocale => ({
                locale: 'de',
                locales: [importedLocale.default],
            }));
        },
    }
};
